export default __webpack_public_path__ + "static/Ambit-SemiBold-4e603bcd7a6e3ea7870fa2d7c8c6b554.woff2";